<template>
  <v-container v-if="roleAccess" class="management-tabs__container py-0 pb-16">
    <SurgeonJournalsFilter/>
    <SurgeonJournalsData v-if="showDataTable"/>
  </v-container>
  <v-container v-else>
    <v-alert prominent type="error">
      <v-row align="center" class="my-0 py-5">
        <v-col class="grow">Access Denied by Role</v-col>
      </v-row>
    </v-alert>
  </v-container>
</template>

<script>
  import SurgeonJournalsFilter from '@/components/surgeonJournals/SurgeonJournalsFilter';
  import SurgeonJournalsData from '@/components/surgeonJournals/SurgeonJournalsData';

  export default {
    name: 'SurgeonJournals',

    components: {SurgeonJournalsData, SurgeonJournalsFilter},

    mounted: async function () {
      ga('set', 'page', '/management/surgeon-journals');
      ga('send', 'pageview');
      if (this.isAdmin) {
        await this.$store.dispatch('getTreatmentTypes');
        await this.$store.dispatch('getSurgeons');
      }
    },

    destroyed: function () {
      this.$store.commit('surgeonJournals/updateShowDataTable', false);
    },

    computed: {
      isAdmin: function () {
        return this.$store.getters.isAdmin;
      },
      roleAccess: function () {
        return this.isAdmin;
      },
      showDataTable: function () {
        return this.$store.state.surgeonJournals.showDataTable;
      },
    },
  };
</script>
